const formatoNumero = (valor) => Number(valor || 0).toLocaleString("es-MX");

export const textoPrecioMensual = (precio) =>
    `${Number(precio || 0).toLocaleString("es-MX", { style: "currency", currency: "MXN" })} al mes (sin IVA)`;

export const textoLimitesPaquete = (paquete) =>
    paquete.sinLimite
        ? "Consultas sin límite"
        : `${formatoNumero(paquete.consultasDiarias)} diarias / ${formatoNumero(paquete.consultasMensuales)} mensuales`;

export const textoPrecioPaquete = (paquete) =>
    paquete.interno ? "Paquete interno" : textoPrecioMensual(paquete.precioMensual);
